import React from "react";
import {
  Container,
  ContentArea,
  TitlePage,
} from "./styles";
import IconsBar from "../../components/IconsBar/IconsBar";
import Header from "../../components/Header";
import { IntegranteTabs } from "../../components/IntegranteTabs/IntegranteTabs";

export const Integrante = () => {
  return (
    <Container>
      <Header />
      <IconsBar />
      <ContentArea>
        <TitlePage>Rotinas do Integral</TitlePage>
        <IntegranteTabs />
      </ContentArea>
    </Container>
  );
};

export default Integrante;
